import { render, staticRenderFns } from "./CollectionUnitStandards.vue?vue&type=template&id=5252ac34"
import script from "./CollectionUnitStandards.vue?vue&type=script&lang=js"
export * from "./CollectionUnitStandards.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnitStandards.vue?vue&type=style&index=0&id=5252ac34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports